import {ErrorMessage} from '@hookform/error-message';
import React, {useEffect, useState} from 'react';
import {Controller, useForm} from 'react-hook-form';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    getCityList,
    getCountryList,
    getStateList,
} from '../../../services/LocationService';
import {
    getRestaurantSettings,
    updateRestaurantSettings,
} from '../../../services/SettingsService';
import {objectToFormData} from '../../../utils/objectToFormData';
import FormInput from '../Registration/FormInput';
import FormSelectInput from '../Registration/FormSelectInput';
import GMap from '../Registration/Map';
const RestaurantSettings = () => {
    const {
        handleSubmit,
        formState: {errors},
        register,
        control,
        setValue,
        watch,
        resetField,
        reset,
    } = useForm({mode: 'all'});
    const [countryList, setCountryList] = useState('');
    const [stateList, setStateList] = useState('');
    const [cityList, setCityList] = useState('');
    const [stateLoading, setStateLoading] = useState(false);
    const [cityLoading, setCityLoading] = useState(false);
    const [resSettings, setResSettings] = useState();
    const [existingImages, setExistingImages] = useState({
        img1: '',
        img2: '',
        img3: '',
        img4: '',
    });
    const watchCountrySelection = watch('country_id', null);
    const watchStateSelection = watch('state_id', null);

    const notify = (id, type, message, time) => {
        toast.update(id, {
            render: message,
            type: type,
            position: 'top-center',
            autoClose: time,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            isLoading: false,
        });
    };
    useEffect(() => {
        const unloadCallback = event => {
            event.preventDefault();
            event.returnValue = '';
            return '';
        };
        window.addEventListener('beforeunload', unloadCallback);
        return () => window.removeEventListener('beforeunload', unloadCallback);
    }, []);

    useEffect(() => {
        const fetchCountryList = async () => {
            const res = await getCountryList();
            setCountryList(res);
        };
        fetchCountryList();
    }, []);

    // useEffect(() => {
    //     loadingToggleAction(true);
    //     (async () => {
    //         let fullCountryList = await getCountryList();
    //         console.log('fullCountryList', fullCountryList);
    //         setCountryList(fullCountryList);
    //         console.log('country', fullCountryList);
    //         loadingToggleAction(false);
    //     })();
    // }, [loadingToggleAction]);

    useEffect(() => {
        if (watchCountrySelection) {
            console.log('watchCountrySelection', watchCountrySelection);
            const fetchStates = async () => {
                setStateLoading(true);
                try {
                    const fullStateList = await getStateList(
                        watchCountrySelection
                    );
                    console.log('fullStateList', fullStateList);
                    setStateList(fullStateList);
                } catch (error) {
                    console.error(error);
                } finally {
                    setStateLoading(false);
                    resetField('state');
                }
            };
            fetchStates();
        }
    }, [watchCountrySelection]);

    useEffect(() => {
        if (watchStateSelection && watchCountrySelection) {
            const fetchCities = async () => {
                setCityLoading(true);
                try {
                    const fullCityList = await getCityList(
                        watchCountrySelection,
                        watchStateSelection
                    );
                    setCityList(fullCityList);
                } catch (error) {
                    console.error(error);
                } finally {
                    setCityLoading(false);
                    resetField('city');
                }
            };
            fetchCities();
        }
    }, [watchCountrySelection, watchStateSelection]);

    useEffect(() => {
        getRestaurantSettings().then(res => {
            setResSettings(res);

            // Extract filenames from image paths
            const extractFilename = path => {
                if (!path) return '';
                const filename = path.split('/').pop();
                return filename.length > 20
                    ? filename.slice(0, 20) + '...'
                    : filename;
            };

            setExistingImages({
                img1: extractFilename(res.img1),
                img2: extractFilename(res.img2),
                img3: extractFilename(res.img3),
                img4: extractFilename(res.img4),
            });
        });
        register('lati', {required: 'Map location is required!'});
        register('longi', {required: true});
    }, [register]);

    useEffect(() => {
        if (resSettings) {
            // Use reset to populate all form fields at once
            reset({
                rest_name: resSettings.restaurant_name || '',
                bank_name: resSettings.bank_name || '',
                acc_no: resSettings.acc_no || '',
                rest_mobile: resSettings.mobile || '',
                rest_email: resSettings.email || '',
                lati: resSettings.lati || '',
                longi: resSettings.longi || '',
                country: resSettings.country || '',
                country_id: resSettings.country_id || '',
                state: resSettings.state || '',
                state_id: resSettings.state_id || '',
                city: resSettings.city || '',
                city_id: resSettings.city_id || '',
                place: resSettings.place || '',
                zip_code: resSettings.zip_code || '',
                is_cater: resSettings.is_catering || false,
                is_dining: resSettings.is_dining || false,
                is_takeaway: resSettings.is_takeaway || false,
                is_delivery: resSettings.is_delivery || false,
            });
        }
    }, [resSettings, reset]);

    // const onSubmit = async data => {
    //     let sendData = {};
    //     if (data.img1.length) sendData['img1'] = data.img1[0];
    //     if (data.img2.length) sendData['img2'] = data.img2[0];
    //     if (data.img3.length) sendData['img3'] = data.img3[0];
    //     if (data.img4.length) sendData['img4'] = data.img4[0];

    //     // Check if at least one image exists or is uploaded
    //     if (
    //         !sendData.img1 &&
    //         !sendData.img2 &&
    //         !sendData.img3 &&
    //         !sendData.img4 &&
    //         !existingImages.img1 &&
    //         !existingImages.img2 &&
    //         !existingImages.img3 &&
    //         !existingImages.img4
    //     ) {
    //         notify('Atleast one image is required!', 'error');
    //         return;
    //     }

    //     // finalSubmit(sendData);)
    //     const toaster = toast.loading('Updating...');
    //     let postData = objectToFormData(data);
    //     let res = await updateRestaurantSettings(postData);
    //     toast.dismiss(toaster);
    //     if (res.status === 'success') {
    //         notify(toaster, 'success', 'Updated Restaurant Settings!', 2000);
    //     } else {
    //         toast.dismiss(toaster);
    //         notify(toaster, 'error', res.data.message, 2000);
    //     }
    // };

    const onSubmit = async data => {
        // build sendData...
        const hasNew = k => data[k] && data[k].length;
        const sendData = {};
        ['img1', 'img2', 'img3', 'img4'].forEach(k => {
            if (hasNew(k)) sendData[k] = data[k][0];
        });

        const hasAny =
            Object.keys(sendData).length > 0 ||
            existingImages?.img1 ||
            existingImages?.img2 ||
            existingImages?.img3 ||
            existingImages?.img4;

        if (!hasAny) {
            toast.error('At least one image is required!', {
                position: 'top-center',
            });
            return;
        }

        const id = toast.loading('Updating...');
        try {
            const postData = objectToFormData(data);
            const res = await updateRestaurantSettings(postData);

            if (res.status === 'success') {
                notify(id, 'success', 'Updated Restaurant Settings!', 2000);
            } else {
                notify(id, 'success', 'Updated Restaurant Settings!', 2000);
            }
        } catch (err) {
            notify(id, 'error', err?.message || 'Something went wrong', 3000);
        }
    };
    const watchImage1 = watch('img1', null);
    const watchImage2 = watch('img2', null);
    const watchImage3 = watch('img3', null);
    const watchImage4 = watch('img4', null);

    // Add these lines to get current lat/lng from form
    const watchLati = watch('lati', null);
    const watchLongi = watch('longi', null);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='container mt-5'>
                    <h4 className='mb-4 text-center'>Restaurant Details</h4>
                    <div className='row justify-content-between'>
                        <div className='col-lg-10'>
                            <FormInput
                                label={'Restaurant Name'}
                                id={'val-rest-name'}
                                name={'rest_name'}
                                required={true}
                                ErrorMessage={ErrorMessage}
                                register={{
                                    ...register('rest_name', {
                                        required:
                                            'Restaurant name is required!',
                                    }),
                                }}
                                errors={errors}
                            />
                            <FormInput
                                label={'Bank Name'}
                                id={'val-bank'}
                                name={'bank_name'}
                                required={true}
                                ErrorMessage={ErrorMessage}
                                register={{
                                    ...register('bank_name', {
                                        required: 'Bank name is required!',
                                    }),
                                }}
                                errors={errors}
                            />
                            <FormInput
                                label={'Bank Account Number'}
                                id={'val-bank-acct-no'}
                                name={'acc_no'}
                                required={true}
                                ErrorMessage={ErrorMessage}
                                register={{
                                    ...register('acc_no', {
                                        required:
                                            'Bank account number is required!',
                                        pattern: {
                                            value: /^(0|[0-9]\d*)(\.\d+)?$/,
                                            message:
                                                'Invalid account number provided!',
                                        },
                                    }),
                                }}
                                errors={errors}
                            />
                            <FormInput
                                label={'Contact Number'}
                                id={'val-rest-mobile'}
                                name={'rest_mobile'}
                                maxLength={15}
                                required={true}
                                ErrorMessage={ErrorMessage}
                                register={{
                                    ...register('rest_mobile', {
                                        required: 'Contact number is required!',
                                        pattern: {
                                            value: /^\+[0-9]{1,3}\s?[0-9]{3}\s?[0-9]{3}\s?[0-9]{4}$/,
                                            message:
                                                'Invalid contact number provided!',
                                        },
                                    }),
                                }}
                                errors={errors}
                            />
                            <FormInput
                                label={'Restaurant Email'}
                                type='text'
                                id={'val-rest-email'}
                                name={'rest_email'}
                                required={true}
                                ErrorMessage={ErrorMessage}
                                className='form-control'
                                register={{
                                    ...register('rest_email', {
                                        required:
                                            'Restaurant Email is required!',
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                            message: 'Invalid email provided!',
                                        },
                                    }),
                                }}
                                errors={errors}
                            />
                        </div>
                        <div className='col-10'>
                            <GMap
                                setValue={setValue}
                                ErrorMessage={ErrorMessage}
                                errors={errors}
                                names={['lati', 'longi']}
                                valueLat={watchLati}
                                valueLng={watchLongi}
                            />
                        </div>
                        <div className='col-10'>
                            <FormSelectInput
                                label={'Country'}
                                id={'val-country'}
                                name={'country_id'}
                                required={true}
                                ErrorMessage={ErrorMessage}
                                Controller={Controller}
                                control={control}
                                errors={errors}
                                rules={{required: 'Country is required!'}}
                                register={{
                                    ...register('country_id', {
                                        required: 'Country is required!',
                                    }),
                                }}
                                options={
                                    countryList
                                        ? countryList
                                        : [
                                              {
                                                  value: null,
                                                  label: 'Loading...',
                                              },
                                          ]
                                }
                            />
                            {stateLoading ? (
                                <></>
                            ) : (
                                // <div style={{height: '100px'}}>
                                //     <div className='sk-three-bounce'>
                                //         <div className='sk-child sk-bounce1'></div>
                                //         <div className='sk-child sk-bounce2'></div>
                                //         <div className='sk-child sk-bounce3'></div>
                                //     </div>
                                // </div>
                                <FormSelectInput
                                    label={'State'}
                                    id={'val-state'}
                                    name={'state_id'}
                                    required={true}
                                    ErrorMessage={ErrorMessage}
                                    Controller={Controller}
                                    control={control}
                                    errors={errors}
                                    rules={{required: 'State is required!'}}
                                    register={{
                                        ...register('state_id', {
                                            required: 'State is required!',
                                        }),
                                    }}
                                    options={
                                        stateList && watchCountrySelection
                                            ? stateList
                                            : [
                                                  {
                                                      value: null,
                                                      label: 'Select Country...',
                                                  },
                                              ]
                                    }
                                />
                            )}
                            {cityLoading ? (
                                <>
                                    {/* <div style={{height: '100px'}}>
                                        <div className='sk-three-bounce'>
                                            <div className='sk-child sk-bounce1'></div>
                                            <div className='sk-child sk-bounce2'></div>
                                            <div className='sk-child sk-bounce3'></div>
                                        </div>
                                    </div> */}
                                </>
                            ) : (
                                <FormSelectInput
                                    label={'City'}
                                    id={'val-city'}
                                    name={'city_id'}
                                    required={true}
                                    ErrorMessage={ErrorMessage}
                                    Controller={Controller}
                                    control={control}
                                    errors={errors}
                                    rules={{required: 'City is required!'}}
                                    register={{
                                        ...register('city_id', {
                                            required: 'City is required!',
                                        }),
                                    }}
                                    options={
                                        cityList &&
                                        watchStateSelection &&
                                        watchCountrySelection
                                            ? cityList
                                            : [
                                                  {
                                                      value: null,
                                                      label: 'Select State...',
                                                  },
                                              ]
                                    }
                                />
                            )}
                            <FormInput
                                label={'Place'}
                                id={'val-place'}
                                name={'place'}
                                required={true}
                                ErrorMessage={ErrorMessage}
                                register={{
                                    ...register('place', {
                                        required: 'Place is required!',
                                    }),
                                }}
                                errors={errors}
                            />
                            <FormInput
                                label={'Postal Code'}
                                id={'val-zip-code'}
                                name={'zip_code'}
                                required={true}
                                ErrorMessage={ErrorMessage}
                                register={{
                                    ...register('zip_code', {
                                        required: 'Postal Code is required!',
                                        pattern: {
                                            value: /^([0-9]\d*)$/,
                                            message:
                                                'Invalid postal code provided!',
                                        },
                                    }),
                                }}
                                errors={errors}
                            />
                        </div>
                        <h4 className='mb-4 text-center mt-3'>
                            Restaurant Service Provided
                        </h4>
                        <div className='col-12 '>
                            <div className='custom-control custom-checkbox mb-3 checkbox-info'>
                                <input
                                    type='checkbox'
                                    defaultChecked
                                    className='custom-control-input'
                                    {...register('is_cater')}
                                    id='val-is-cater'
                                />
                                <label
                                    className='custom-control-label'
                                    htmlFor='val-is-cater'
                                >
                                    Provides Catering Service
                                </label>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='custom-control custom-checkbox mb-3 checkbox-info'>
                                <input
                                    type='checkbox'
                                    defaultChecked
                                    className='custom-control-input'
                                    {...register('is_dining')}
                                    id='val-is-dining'
                                />
                                <label
                                    className='custom-control-label'
                                    htmlFor='val-is-dining'
                                >
                                    Provides Dine-in Option
                                </label>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='custom-control custom-checkbox mb-3 checkbox-info'>
                                <input
                                    type='checkbox'
                                    defaultChecked
                                    className='custom-control-input'
                                    {...register('is_takeaway')}
                                    id='val-is-takeaway'
                                />
                                <label
                                    className='custom-control-label'
                                    htmlFor='val-is-takeaway'
                                >
                                    Provides Take Away Service
                                </label>
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='custom-control custom-checkbox mb-3 checkbox-info'>
                                <input
                                    type='checkbox'
                                    defaultChecked
                                    className='custom-control-input'
                                    {...register('is_delivery')}
                                    id='val-is-delivery'
                                />
                                <label
                                    className='custom-control-label'
                                    htmlFor='val-is-delivery'
                                >
                                    Provides Delivery Service
                                </label>
                            </div>
                        </div>
                        <h4 className='mb-4 text-center mt-3 justify-content-center'>
                            Restaurant Images
                        </h4>
                        <div className='column m-5 justify-content-center'>
                            <div className='basic-form custom_file_input  justify-content-center'>
                                <div className='input-group'>
                                    <div className='custom-file mb-1'>
                                        <input
                                            type='file'
                                            className='custom-file-input'
                                            {...register('img1')}
                                            id='val-img1'
                                        />
                                        <label className='custom-file-label'>
                                            {existingImages.img1
                                                ? ''
                                                : 'Image 1'}
                                            {watchImage1 && watchImage1[0]
                                                ? '[Uploaded:' +
                                                  watchImage1[0].name.slice(
                                                      0,
                                                      20
                                                  ) +
                                                  '...]'
                                                : existingImages.img1
                                                ? existingImages.img1
                                                : ''}
                                        </label>
                                    </div>
                                    {(watchImage1 && watchImage1[0]) ||
                                    existingImages.img1 ? (
                                        <div
                                            className='ml-2 mt-1 bootstrap-badge'
                                            type='button'
                                            onClick={() => {
                                                resetField('img1');
                                                setExistingImages(prev => ({
                                                    ...prev,
                                                    img1: '',
                                                }));
                                            }}
                                        >
                                            <span className='badge badge-primary light'>
                                                <i className='fa fa-close'></i>
                                            </span>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <ErrorMessage
                                    errors={errors}
                                    name='img1'
                                    render={({message}) => (
                                        <div className='text-danger fs-12'>
                                            {message}
                                        </div>
                                    )}
                                />
                                <div className='input-group mt-4 mb-4'>
                                    <div className='custom-file'>
                                        <input
                                            type='file'
                                            className='custom-file-input'
                                            {...register('img2')}
                                            id='val-img2'
                                        />
                                        <label className='custom-file-label'>
                                            {existingImages.img2
                                                ? ''
                                                : 'Image 2'}
                                            {watchImage2 && watchImage2[0]
                                                ? '[Uploaded:' +
                                                  watchImage2[0].name.slice(
                                                      0,
                                                      20
                                                  ) +
                                                  '...]'
                                                : existingImages.img2
                                                ? existingImages.img2
                                                : ''}
                                        </label>
                                    </div>
                                    {(watchImage2 && watchImage2[0]) ||
                                    existingImages.img2 ? (
                                        <div
                                            className='ml-2 mt-1 bootstrap-badge'
                                            type='button'
                                            onClick={() => {
                                                resetField('img2');
                                                setExistingImages(prev => ({
                                                    ...prev,
                                                    img2: '',
                                                }));
                                            }}
                                        >
                                            <span className='badge badge-primary light'>
                                                <i className='fa fa-close'></i>
                                            </span>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <div className='input-group mb-4'>
                                    <div className='custom-file'>
                                        <input
                                            type='file'
                                            className='custom-file-input'
                                            {...register('img3')}
                                            id='val-img3'
                                        />
                                        <label className='custom-file-label'>
                                            {existingImages.img3
                                                ? ''
                                                : 'Image 3'}
                                            {watchImage3 && watchImage3[0]
                                                ? '[Uploaded:' +
                                                  watchImage3[0].name.slice(
                                                      0,
                                                      20
                                                  ) +
                                                  '...]'
                                                : existingImages.img3
                                                ? existingImages.img3
                                                : ''}
                                        </label>
                                    </div>
                                    {(watchImage3 && watchImage3[0]) ||
                                    existingImages.img3 ? (
                                        <div
                                            className='ml-2 mt-1 bootstrap-badge'
                                            type='button'
                                            onClick={() => {
                                                resetField('img3');
                                                setExistingImages(prev => ({
                                                    ...prev,
                                                    img3: '',
                                                }));
                                            }}
                                        >
                                            <span className='badge badge-primary light'>
                                                <i className='fa fa-close'></i>
                                            </span>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <div className='input-group mb-4'>
                                    <div className='custom-file'>
                                        <input
                                            type='file'
                                            className='custom-file-input'
                                            {...register('img4')}
                                            id='val-img4'
                                        />
                                        <label className='custom-file-label'>
                                            {existingImages.img4
                                                ? ''
                                                : 'Image 4'}
                                            {watchImage4 && watchImage4[0]
                                                ? '[Uploaded:' +
                                                  watchImage4[0].name.slice(
                                                      0,
                                                      20
                                                  ) +
                                                  '...]'
                                                : existingImages.img4
                                                ? existingImages.img4
                                                : ''}
                                        </label>
                                    </div>
                                    {(watchImage4 && watchImage4[0]) ||
                                    existingImages.img4 ? (
                                        <div
                                            className='ml-2 mt-1 bootstrap-badge'
                                            type='button'
                                            onClick={() => {
                                                resetField('img4');
                                                setExistingImages(prev => ({
                                                    ...prev,
                                                    img4: '',
                                                }));
                                            }}
                                        >
                                            <span className='badge badge-primary light'>
                                                <i className='fa fa-close'></i>
                                            </span>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='justify-content-center'>
                        <button
                            type='submit'
                            className='next btn btn-primary ml-1'
                        >
                            Update Restaurant Settings
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default RestaurantSettings;
